export default __webpack_public_path__ + "static/media/storageCheckID.c1a1a527.jpg";